import { createContext } from 'react'

import { keycloak } from 'lib/keycloak'

import type { IKeycloakContext } from './keycloak.types'

const KEYCLOAK_FALLBACK: IKeycloakContext = {
  keycloak,
  initialized: false,
}

export const KeycloakContext = createContext<IKeycloakContext>(KEYCLOAK_FALLBACK)
